module.exports = __webpack_public_path__ + "static/media/claims-magic-moment.55360a26.svg";